// Public classes.
export { SpellCheckerService } from './services/spellchecker.service';
export { SpellCheckerModule } from './modules/spellchecker.module';
